export default __webpack_public_path__ + "static/media/trophy2.33043555.svg";